let analysis_options = [
        {
            value: "日期",
            label: "time",
        },
        {
            value: "分公司/分行",
            label: "branch",
        },
        {
            value: "部門",
            label: "department",
        },
        {
            value: "下單員",
            label: "member",
        },
        {
            value: "訂單號",
            label: "order",
        },
        {
            value: "商品",
            label: "goods",
        },
        {
            value: "品牌",
            label: "brand",
        },
        {
            value: "商品編號",
            label: "sn",
        },
        {
            value: "商品數量",
            label: "num",
        },
        {
            value: "商品單價",
            label: "unit_price",
        },
        {
            value: "平均單價",
            label: "average_price",
        },
        {
            value: "地區",
            label: "area",
        },
        {
            value: "商品描述",
            label: "describe",
        },
        {
            value: "行業平均單價",
            label: "industry_price",
        },
        {
            value: "行業平均數量",
            label: "industry_number",
        },
        {
            value: "澳門平均單價",
            label: "Macao_price",
        },
        {
            value: "澳門平均數量",
            label: "Macao_number",
        }
    ]

export { analysis_options }